import CartNumber from "@assets/images/cart-number.png";
import PINumber from "@assets/images/PI-Number.png";
import SoldToNumber from "@assets/images/sold-to-number.png";
import { Grid } from "@material-ui/core";
import MyTypography from "@saleor/components/MyTypography";
import { ExportCartsSearchQuery } from "@saleor/graphql";
import { makeStyles } from "@saleor/macaw-ui";
import React from "react";
import { useIntl } from "react-intl";

interface CartSummaryProps {
  exportCartsData: ExportCartsSearchQuery;
}

const useStyles = makeStyles(
  theme => ({
    summaryHeading: {
      marginBottom: "24px"
    },
    summaryCard: {
      padding: "1.6rem 2.4rem",
      background: "#FFFFFF",
      borderRadius: 6,
      marginBottom: 16
    },
    summaryIcon: {
      background: "rgba(0, 159, 184, 0.1)",
      borderRadius: 4,
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    },
    summaryTitle: {
      color: theme.palette.grey[700]
    },
    summaryText: {
      color: theme.palette.grey[700],
      marginBottom: "16px"
    },
    summaryTotal: {
      fontSize: "34px",
      color: theme.palette.grey[800]
    }
  }),
  {
    name: "CartSummary"
  }
);

const CartSummary: React.FC<CartSummaryProps> = props => {
  const { exportCartsData } = props;
  const intl = useIntl();

  const classes = useStyles();

  return (
    <>
      <Grid container className={classes.summaryCard}>
        <Grid item xs={10}>
          <MyTypography variant="h6" className={classes.summaryTitle}>
            {intl.formatMessage({ defaultMessage: "PI No." })}
          </MyTypography>
          <MyTypography variant="body3" className={classes.summaryText}>
            {intl.formatMessage({ defaultMessage: "รวมทั้งหมด (รายการ)" })}
          </MyTypography>
          <MyTypography variant="body2" className={classes.summaryTotal}>
            {exportCartsData?.exportCartsSearch?.totalPi || 0}
          </MyTypography>
        </Grid>
        <Grid item xs={2} className={classes.summaryIcon}>
          <img src={PINumber} alt="PINumber" />
        </Grid>
      </Grid>
      <Grid container className={classes.summaryCard}>
        <Grid item xs={10}>
          <MyTypography variant="h6" className={classes.summaryTitle}>
            {intl.formatMessage({ defaultMessage: "Sold to" })}
          </MyTypography>
          <MyTypography variant="body3" className={classes.summaryText}>
            {intl.formatMessage({ defaultMessage: "ลูกค้าทั้งหมด (ราย)" })}
          </MyTypography>
          <MyTypography variant="body2" className={classes.summaryTotal}>
            {exportCartsData?.exportCartsSearch?.totalSoldTo || 0}
          </MyTypography>
        </Grid>
        <Grid item xs={2} className={classes.summaryIcon}>
          <img src={SoldToNumber} alt="SoldToNumber" />
        </Grid>
      </Grid>
      <Grid container className={classes.summaryCard}>
        <Grid item xs={10}>
          <MyTypography variant="h6" className={classes.summaryTitle}>
            {intl.formatMessage({ defaultMessage: "สินค้าในตะกร้า" })}
          </MyTypography>
          <MyTypography variant="body3" className={classes.summaryText}>
            {intl.formatMessage({ defaultMessage: "รวมทั้งหมด (รายการ)" })}
          </MyTypography>
          <MyTypography variant="body2" className={classes.summaryTotal}>
            {exportCartsData?.exportCartsSearch?.totalCartItem || 0}
          </MyTypography>
        </Grid>
        <Grid item xs={2} className={classes.summaryIcon}>
          <img src={CartNumber} alt="CartNumber" />
        </Grid>
      </Grid>
    </>
  );
};

export default CartSummary;
